var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2214_39557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 240C152.66 123.526 188 92.6231 188 2",
    stroke: "#DBDBDB",
    strokeOpacity: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.146 1042C650.146 1042 641.116 926.958 673.75 757.818C710.038 569.746 796.21 463.076 820.399 252.606C830.971 160.627 827.43 0 827.43 0",
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.18 1024C372.18 1024 243.039 745.727 266.954 541.505C273.428 486.219 385.929 103.583 382.942 48.0181C381.675 24.4621 372.18 0 372.18 0",
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1072 1024C1113.16 753.814 1191.42 615.768 1440 396",
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250 1024C1271.25 894.93 1311.66 828.985 1440 724",
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 121.5,
    r: 5.5,
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 235.5,
    r: 3.5,
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1222,
    cy: 903,
    r: 9.5,
    stroke: "#DBDBDB",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2214_39557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgLight);
export default __webpack_public_path__ + "static/media/bg-light.6306b8c3c9c9ea43dcc038b3ace385bc.svg";
export { ForwardRef as ReactComponent };